import React from "react";
import './Unauthorized.css';
import logoImage from "../../assets/eucomex-logo.png";
import useLogout from "../../hooks/useLogout";

const Unauthorized = () => {

    const logout = useLogout();

    const handleLogout = () => {
        logout()
    };

    return (
        <div className="unauthorized-container">
            <img src={logoImage} alt="Logo" className="login-logo" />
            <div className="unauthorized-wrapper">
                <h1 className="unauthorized-title">¡Ha ocurrido un problema!</h1>
                <p className="unauthorized-description">
                    Si fuiste mandado a esta página puede ser por las siguientes razones:
                </p>
                <ul className="unauthorized-list">
                    <li className="unauthorized-list-item">
                        Tu sesión expiró (solamente dura horas), por lo cual tienes que volver a iniciar sesión
                    </li>
                    <li className="unauthorized-list-item">
                        No tienes acceso a estos recursos
                    </li>
                    <li className="unauthorized-list-item">
                        Hubo un problema con el sistema. En caso de ser algo recurrente, contacte al administrador del sistema
                    </li>
                </ul>
                <p className="unauthorized-description">
                    Por favor vuelve a{" "}
                    <span
                        className="unauthorized-link"
                        onClick={handleLogout} // Attach the click handler
                    >
            iniciar sesión
          </span>
                </p>
            </div>
        </div>
    );
};

export default Unauthorized;